import { useRef, useCallback } from 'react';
import { GtmService } from '../services/gtm.service';

export const useSwiperTracking = (gtmData, onTrackCustom) => {
    const interactionType = useRef(null);

    const onTouchStartHandler = useCallback(() => {
        interactionType.current = 'swipe';
    }, []);

    const onArrowClickHandler = useCallback(() => {
        interactionType.current = 'arrow';
    }, []);

    const onSlideChangeHandler = useCallback(() => {
        if (!interactionType.current) {return;}

        const clickElement = interactionType.current === 'arrow' ? 'icon' : 'swipe';

        if (typeof onTrackCustom === 'function') {
            onTrackCustom(clickElement);
        } else {
            GtmService.track({
                ...gtmData,
                click_element: clickElement,
                click_action: 'navigation',
            });
        }

        interactionType.current = null;
    }, [gtmData, onTrackCustom]);

    return {
        onTouchStartHandler,
        onArrowClickHandler,
        onSlideChangeHandler,
    };
};
